<script>
import VehicleInfoComponent from '@/components/VehicleInfoComponent'
import RightLayout from '@/router/layouts/rightLayout'
export default {
  components: { VehicleInfoComponent, RightLayout }
}
</script>

<template>
<right-layout>
  <vehicle-info-component
  :title="'車両ブロック編集'"
  :btnName="'保存'"
  :type="'block'"
  :func="'block-editor'"
  ></vehicle-info-component>
</right-layout>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/router/views/VehicleBlockEditor.vue